export const containerYardConstants = {
    CY_FETCHING: 'CY_FETCHING',
    CY_FETCHED: 'CY_FETCHED',
    CY_SUBMITTING: 'CY_SUBMITTING',
    CY_SUBMITTED: 'CY_SUBMITTED',
    GET_CONTAINER_YARDS: 'GET_CONTAINER_YARDS',
    GET_CONTAINER_YARD_BY_ID: 'GET_CONTAINER_YARD_BY_ID',
    GET_ACTIVE_CONTAINER_YARDS: 'GET_ACTIVE_CONTAINER_YARDS'
}